import React from 'react';
import {
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,
} from '@mui/material';
import { BieMetricRow } from './types';
import { formatMoney, formatPercent } from './format';

type Props = {
  rows: BieMetricRow[];
};

const ScenarioComparePanel: React.FC<Props> = ({ rows }) => {
  return (
    <Paper elevation={1} sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Scenario Comparison</Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Group</TableCell>
              <TableCell>Metric</TableCell>
              <TableCell align="right">Base</TableCell>
              <TableCell align="right">Target</TableCell>
              <TableCell align="right">Variance</TableCell>
              <TableCell align="right">Variance %</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={`${row.metricgroup}-${row.metriccode}`} hover>
                <TableCell>{row.metricgroup}</TableCell>
                <TableCell>{row.metricname}</TableCell>
                <TableCell align="right">{formatMoney(row.basevalue)}</TableCell>
                <TableCell align="right">{formatMoney(row.targetvalue)}</TableCell>
                <TableCell align="right">{formatMoney(row.variancevalue)}</TableCell>
                <TableCell align="right">{formatPercent(row.variancepercent)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ScenarioComparePanel;
